import type { SourcePlatform } from '~entities/import-job/api/types';

export const SOURCE_PLATFORMS = [
  'jackrabbit',
  'studio_pro',
  'studio_director',
  'dsp',
  'csv',
] as const satisfies readonly SourcePlatform[];

export const WIZARD_STEPS = [
  { id: 0, label: 'Where you\'re coming from' },
  { id: 1, label: 'Your classes' },
  { id: 2, label: 'Class photos' },
  { id: 3, label: 'Your families' },
  { id: 4, label: 'Your welcome email' },
  { id: 5, label: 'Review and launch' },
] as const;

export const PLATFORM_OPTIONS: Array<{
  id: SourcePlatform;
  label: string;
  description: string;
}> = [
  {
    id: 'jackrabbit',
    label: 'Jackrabbit',
    description: 'Roster export with Lesson Format, Customer, and student columns.',
  },
  {
    id: 'studio_pro',
    label: 'Studio Pro',
    description: 'Student Name, Parent, Parent Phone, and Parent Email columns.',
  },
  {
    id: 'studio_director',
    label: 'Studio Director',
    description:
      'Classes (Name, Day, Length→End Time) and families (Guardian, Student N Name/DOB).',
  },
  {
    id: 'csv',
    label: 'Upload CSV',
    description:
      'Any valid CSV — you map each column to the fields Enrollio needs.',
  },
];

/** Placeholder Loom URLs — replace with platform-specific onboarding videos. */
export const PLATFORM_LOOM_URLS: Partial<Record<SourcePlatform, string>> = {
  jackrabbit: 'https://www.loom.com/embed/placeholder-jackrabbit',
  studio_pro: 'https://www.loom.com/embed/placeholder-studio-pro',
  studio_director: 'https://www.loom.com/embed/placeholder-studio-director',
  dsp: 'https://www.loom.com/embed/placeholder-dsp',
  csv: 'https://www.loom.com/embed/placeholder-csv',
};
